import { ActionParams } from '../../types/constants'
import { ActionsList } from '../../util/contstants'
import { NumericalChangeActionsE, State } from '../../constants'

export const resolveDefaultActionParams = (action: number): ActionParams => {
    switch (action) {
        case ActionsList.SetState:
            return {
                type: ActionsList.SetState,
                extra: State.Paused,
            }
        case ActionsList.SetDailyBudget:
        case ActionsList.SetDefaultBid:
        case ActionsList.SetBid:
            return {
                type: action,
                extra: {
                    action: NumericalChangeActionsE.DecreasePercent,
                    value: 0,
                    source: 'value',
                },
            }
        case ActionsList.CreateExactMatchNegative:
            return {
                type: ActionsList.CreateExactMatchNegative,
            }
        case ActionsList.ChangeBiddingStrategy:
            return { type: action, extra: 'SALES_DOWN_ONLY' } as ActionParams
        case ActionsList.ChangeBidAdjustment:
            return { type: action, extra: { tos_placement: 0 } } as ActionParams
        default:
            throw new Error('Unhandled action: ' + action)
    }
}
